import React from "react";
import {Link} from "react-router-dom";
import {Modal} from "react-bootstrap";
import ProductPage from "../product/Product";

/**
 * Страница товара в модальном окне поверх чата консультанта: из мини-карточки и по ссылке на товар в ответе.
 */
export default function ChatProductModal({productId, href, show, onHide}: {
    productId: number
    href: string
    show: boolean
    onHide: () => void
}) {
    return <Modal show={show} onHide={onHide} size="xl" scrollable dialogClassName="chat-product-modal">
        <Modal.Header closeButton>
            <Link to={href} className="small">Открыть страницу товара</Link>
        </Modal.Header>
        <Modal.Body>
            {show && <ProductPage productId={String(productId)} inModal/>}
        </Modal.Body>
    </Modal>;
}

// Клик по ссылке на товар открывает окно; ссылка остаётся ссылкой: в новой вкладке (ctrl/cmd, средняя кнопка) — как раньше
export function openInModal(event: React.MouseEvent, open: () => void) {
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.button !== 0) return;
    event.preventDefault();
    open();
}
